export default "__VITE_ASSET__c4b63f0b__"